import { ArrowRight } from "lucide-react";
import { notifyEarlyAccess } from "./Hero";

export const CtaSection = () => (
  <section id="get-toto" className="py-16 sm:py-24" data-testid="cta-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-toto-blue px-8 py-16 text-center shadow-[0_30px_60px_-20px_rgba(27,44,200,0.5)] sm:px-16 sm:py-20">
        <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-toto-purple/40 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <h2 className="relative font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="cta-heading">
          Your Network Is Your Opportunity.
        </h2>
        <p className="relative mx-auto mt-4 max-w-xl text-base text-indigo-100 sm:text-lg" data-testid="cta-subtext">
          Start organizing every professional connection with TOTO.
        </p>
        <button
          onClick={notifyEarlyAccess}
          data-testid="cta-notify-me-button"
          className="relative mt-8 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-base font-semibold text-toto-blue shadow-lg transition-all hover:-translate-y-0.5 hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-toto-blue"
        >
          Notify Me <ArrowRight className="h-4 w-4" />
        </button>
        <p className="relative mt-4 text-xs uppercase tracking-widest text-indigo-200">Coming soon to iOS &amp; Android</p>
      </div>
    </div>
  </section>
);
